var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentation = function SvgDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M40 20.387V78s-8.3-9.033-36.311-9.387a1.7 1.7 0 0 1-1.19-.508A1.75 1.75 0 0 1 2 66.895V12.718a1.74 1.74 0 0 1 .507-1.223A1.73 1.73 0 0 1 3.75 11C31.708 11.364 40 20.387 40 20.387",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M78.158 11c-5.636.038-11.26.497-16.825 1.374V58L51.5 62 45 68l-3.327 4.657A9 9 0 0 0 40 77.88V79s1.228-1.288 4.319-2.919c5.15-2.717 15.474-6.383 33.903-6.607.47-.005.92-.19 1.252-.516s.521-.767.526-1.228V12.744a1.71 1.71 0 0 0-.54-1.242A1.86 1.86 0 0 0 78.157 11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.4,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M40 78c.553-4.476 2.562-7.74 5.726-10.994A28.9 28.9 0 0 1 61 58.5V3.7a1.64 1.64 0 0 0-.22-.792 1.7 1.7 0 0 0-.578-.59 2.12 2.12 0 0 0-1.73-.228 27.35 27.35 0 0 0-12.746 7.864A20.73 20.73 0 0 0 40 21.854"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M61.333 12.354c5.565-.864 9.19-1.317 14.825-1.354.484-.007.952.17 1.302.495.17.159.304.349.397.559s.142.436.143.664v54.177a1.7 1.7 0 0 1-.526 1.21 1.83 1.83 0 0 1-1.252.508c-18.429.221-26.752 3.833-31.903 6.51C41.23 76.73 40 78 40 78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M61.333 12.354c5.565-.864 9.19-1.317 14.825-1.354.484-.007.952.17 1.302.495.17.159.304.349.397.559s.142.436.143.664v54.177a1.7 1.7 0 0 1-.526 1.21 1.83 1.83 0 0 1-1.252.508c-18.429.221-26.752 3.833-31.903 6.51C41.23 76.73 40 78 40 78M29.474 43.193a74.6 74.6 0 0 0-18.456-3.702m18.456 14.755a74.8 74.8 0 0 0-18.456-3.684"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.861 22.625 4.341 5.92a1.07 1.07 0 0 1-.263 1.446 1.01 1.01 0 0 1-1.315-.131l-5.13-5.13c-.658-.658-.658-1.579 0-2.237.657-.657 1.578-.657 2.236 0 0 0 0 .132.131.132"
  })));
};
export default SvgDocumentation;